/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakessessions1Inputs */

const zh_learn_mistakessessions1 = /** @type {(inputs: Learn_Mistakessessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`涉及资源`)
};

const en_learn_mistakessessions1 = /** @type {(inputs: Learn_Mistakessessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions`)
};

const es_learn_mistakessessions1 = /** @type {(inputs: Learn_Mistakessessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesiones`)
};

/**
* | output |
* | --- |
* | "Sessions" |
*
* @param {Learn_Mistakessessions1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakessessions1 = /** @type {((inputs?: Learn_Mistakessessions1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakessessions1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakessessions1(inputs)
	if (locale === "en") return en_learn_mistakessessions1(inputs)
	return es_learn_mistakessessions1(inputs)
});
export { learn_mistakessessions1 as "learn_mistakesSessions" }